import * as React from "react";
import { 
    CourseItem
} from '~/components/homepage';

export default function Course(props: any) {
    return (
        <div className="Course">
            <p className='Course__our-feature'>OUR FEATURED COURSES:</p>
            <div className="Course__list-courses">
                    <CourseItem 
                        name='Java'
                        hours='5'
                        lessons='10'
                        img='java.png'
                        content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
                    />
                    <CourseItem 
                        name='Scala'
                        hours='2'
                        lessons='7'
                        img='scala.png'
                        content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
                    />
                    <CourseItem 
                        name='Spark'
                        hours='6'
                        lessons='8'
                        img='spark.png'
                        content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
                    />
                    <CourseItem 
                        name='Akka Full'
                        hours='5'
                        lessons='10'
                        img='akka.png'
                        content='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
                    />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/homepage/Course.tsx